// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class X509Identity implements flatbuffers.IUnpackableObject<X509IdentityT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): X509Identity {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsX509Identity(bb: flatbuffers.ByteBuffer, obj?: X509Identity): X509Identity {
    return (obj || new X509Identity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsX509Identity(
    bb: flatbuffers.ByteBuffer,
    obj?: X509Identity,
  ): X509Identity {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new X509Identity()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  certificatePath(): string;
  certificatePath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  certificatePath(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  privateKeyPath(): string;
  privateKeyPath(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  privateKeyPath(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  static startX509Identity(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addCertificatePath(
    builder: flatbuffers.Builder,
    certificatePathOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, certificatePathOffset, 0);
  }

  static addPrivateKeyPath(builder: flatbuffers.Builder, privateKeyPathOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, privateKeyPathOffset, 0);
  }

  static endX509Identity(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // certificate_path
    builder.requiredField(offset, 6); // private_key_path
    return offset;
  }

  static createX509Identity(
    builder: flatbuffers.Builder,
    certificatePathOffset: flatbuffers.Offset,
    privateKeyPathOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    X509Identity.startX509Identity(builder);
    X509Identity.addCertificatePath(builder, certificatePathOffset);
    X509Identity.addPrivateKeyPath(builder, privateKeyPathOffset);
    return X509Identity.endX509Identity(builder);
  }

  unpack(): X509IdentityT {
    return new X509IdentityT(this.certificatePath(), this.privateKeyPath());
  }

  unpackTo(_o: X509IdentityT): void {
    _o.certificatePath = this.certificatePath();
    _o.privateKeyPath = this.privateKeyPath();
  }

  unpackFields(...fields: string[]): X509IdentityT {
    const t = new X509IdentityT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("certificate_path")) {
      t.certificatePath = this.certificatePath();
    }
    if (fieldSet.has("private_key_path")) {
      t.privateKeyPath = this.privateKeyPath();
    }
    return t;
  }
}

export class X509IdentityT implements flatbuffers.IGeneratedObject {
  constructor(
    public certificatePath: string | Uint8Array | null = null,
    public privateKeyPath: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.certificatePath === null || this.certificatePath === undefined) {
      throw new Error('Required field "certificate_path" is not set');
    }
    if (this.privateKeyPath === null || this.privateKeyPath === undefined) {
      throw new Error('Required field "private_key_path" is not set');
    }
    const certificatePath =
      this.certificatePath !== null ? builder.createString(this.certificatePath!) : 0;
    const privateKeyPath =
      this.privateKeyPath !== null ? builder.createString(this.privateKeyPath!) : 0;

    return X509Identity.createX509Identity(builder, certificatePath, privateKeyPath);
  }

  clone(): X509IdentityT {
    const obj = new X509IdentityT();
    obj.certificatePath = this.certificatePath;
    obj.privateKeyPath = this.privateKeyPath;
    return obj;
  }

  equals(other: X509IdentityT): boolean {
    if (this.certificatePath !== other.certificatePath) return false;
    if (this.privateKeyPath !== other.privateKeyPath) return false;
    return true;
  }
}

export function verifyX509Identity(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "certificate_path");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "private_key_path");
  } finally {
    verifier.popDepth();
  }
}
